<div class="w-full flex items-center p-3">
  <span class="dark:text-white leading-7">
    <span *ngIf="questionNumber" class="rtl:ml-1 ltr:mr-1">
      {{questionNumber.toString()|convertToPersian}}.
    </span>
    {{data.text}}
  </span>
  <button *ngIf="config.number_of_permitted_vague_question>0 || config.is_can_comment_on_question" (click)="changeCommentState()" class="rtl:mr-2 ltr:ml-2 flex items-center justify-center h-full aspect-square">
      <mat-icon class="mat-center">
          edit_note
      </mat-icon>
  </button>
</div>
<app-expand-sec (dataEmitter)="updateExpandSecData($event)" (commentEmitter)="sendComment()" [showFormObs]="commentStatusObs$" [config]="{isShowUnknown: config.number_of_permitted_vague_question>0, isShowComment: config.is_can_comment_on_question, questionId: data.id, isUnknownInitalValue: isUnknownInital}"></app-expand-sec>
<div class="w-full relative">
  <div class="flex flex-col items-center py-3" [style]="getCustomStyle()">
    <div class="example-container">
        <div class="w-full flex items-center justify-center mb-1">
          <h2 class="text-center">
            پاسخ‌ها
            <div class="my-1"></div>
            <span @heightZero *ngIf="data.additional_fields.minimum_required_answer - answer.length>0" class="mx-1 text-lightMode-700 dark:text-darkMode-300 text-sm font-normal h-5 block overflow-y-hidden">
              حداقل {{(data.additional_fields.minimum_required_answer - answer.length).toString() | convertToPersian}} گزینه دیگر را انتخاب کنید
            </span>
            <!-- <span class="mx-1 text-lightMode-700 dark:text-darkMode-300 text-sm">
              {{answer.length}}/{{data.additional_fields.minimum_required_answer}}
              {{answer.length < data.additional_fields.minimum_required_answer?'❌':'✅'}}
            </span> -->
          </h2>
        </div>
  
        <div
          cdkDropList
          #questions="cdkDropList"
          [cdkDropListData]="answer"
          [cdkDropListConnectedTo]="[answers]"
          class="example-list relative py-2 rounded-lg bg-lightCardBG dark:bg-darkCardBG border border-lightMode-200 dark:border-darkMode-800 transition-all ease-in-out duration-300"
          (cdkDropListDropped)="drop($event, true)"
          [style]="getErrorStyle()" [class]="answer.length<data.additional_fields.point_of_answer_positions.length? 'pb-[3.17rem]' : 'pb-2'"
          [@shadowAnimation]="warnAnswerObs|async">
          <div class="example-box px-2 py-[2px] bg-transparent" *ngFor="let q of answer;let i = index;" cdkDrag>
            <div  class="rounded-md example-box w-full child py-2 px-3 flex justify-center text-center" [style]="textColor+getOptionBackgroundColor(i)">
              {{q.additional_fields.text}}
            </div>
          </div>

          <div  [class]="answer.length!=0 ? 'bottom-[10px]' : 'bottom-[7px]'" class="absolute left-0 right-0 w-full h-6 mb-[1.3rem] transition-all ease-in-out duration-300 px-2" [style]="answer.length<data.additional_fields.point_of_answer_positions.length? 'opacity:1;display:block;z-index:1' : 'opacity:0;z-index:-1'">
            <div class="w-full h-full rounded-md mt-[7px] border border-dashed border-lightMode-400 dark:border-darkMode-700 text-center p-[1.1rem] text-[#c7c7c7] dark:text-[#666565] flex items-center justify-center bg-[#ffffff01] font-[500] text-[1rem]">
              {{placeholderItem(data.additional_fields.point_of_answer_positions,answer.length)}}
            </div>
          </div>
        </div>
      </div>
      
    <div class="example-container">
      <div class="w-full flex justify-center mb-1">
        <h2 class="mt-3">گزینه‌ها</h2>
      </div>
    
      <div
        cdkDropList
        #answers="cdkDropList"
        [cdkDropListData]="question"
        [cdkDropListConnectedTo]="[questions]"
        class="example-list py-2 rounded-lg bg-lightCardBG dark:bg-darkCardBG border border-lightMode-200 dark:border-darkMode-800"
        (cdkDropListDropped)="drop($event, false)">
        <div [@fadeIn]="translate ? '' : null" [@.disabled]="!translate" class="example-box px-2 py-[2px] bg-transparent" *ngFor="let q of question" cdkDrag>
          <div class="rounded-md example-box w-full child py-2 px-3 flex justify-center text-center bg-lightCardBG dark:bg-darkCardBG outline outline-1 outline-lightMode-300 dark:outline-darkMode-700 text-lightMode-600 dark:text-darkMode-200">
            {{q.additional_fields.text}}
          </div>
        </div>
      </div>
    </div>  
  </div>
  <app-hatch-skin *ngIf="extraData.isUnknown" @hatchFade></app-hatch-skin>
</div>
